module.exports = __webpack_public_path__ + "img/ramadan_banner.afc7685e.png";